// extracted by mini-css-extract-plugin
export default {"body":"View_body__NHWtA"};